import type { Cart, Service } from '@/types/booking';
import { getCartServiceIds } from '@/utils/booking/getCartServiceIds';
import { buildDisplayServices } from '@/utils/buildDisplayServices';

interface GetScreenServicesParams {
  services: Service[] | undefined;
  cart: Cart | null | undefined;
  isAnyProfessional: boolean;
  barberId: string | undefined;
  isCategoryFirstEnabled: boolean;
}

/**
 * Services to list. Any professional is narrowed by the whole cart with
 * category-first on, else by the cart's first service (SQR-13874).
 */
export function getScreenServices({
  services,
  cart,
  isAnyProfessional,
  barberId,
  isCategoryFirstEnabled,
}: GetScreenServicesParams): Service[] {
  const cartServiceIds = getCartServiceIds(cart);
  const primaryService = isAnyProfessional
    ? services?.find(({ id }) => id === cartServiceIds.at(0))
    : undefined;
  const cartServices =
    isCategoryFirstEnabled && isAnyProfessional
      ? services?.filter(({ id }) => cartServiceIds.includes(id))
      : undefined;

  return buildDisplayServices({
    services,
    isAnyProfessional,
    barberId,
    primaryService,
    cartServices,
  });
}
